import { convertToCamelCaseFromUnderScore } from "../../../utils";
import CustomChip from "../../../core/custom-chip";
import { TICKET_STAGES } from "../ticket-details-v2/helper";
import { Box, Tooltip, Typography } from "@mui/material";
import moment from "moment";

export const HeaderConfig = [
  {
    label: "Ticket ID",
    id: "id",
    onClick: true,
    render: (data, onClick) => {
      return (
        <span className="clickable" onClick={() => onClick(data)}>
          {data.id}
        </span>
      );
    },
  },
  {
    label: "Created On",
    id: "createdAt",
    render: (data) => {
      return (
        <span>
          {data.createdAt && moment(data.createdAt).format("DD/MM/YYYY")}{" "}
        </span>
      );
    },
  },
  {
    label: "Created By",
    id: "createdBy",
    render: (data) => {
      return <span>{data?.createdBy?.name}</span>;
    },
  },
  {
    label: "OEM Org",
    id: "oem",
    render: (data) => {
      return <span>{data?.oemOrg?.name}</span>;
    },
  },
  {
    label: "OEM Engineer",
    id: "oemServiceEngineerName",
    render: (data) => {
      return <span>{data?.complaintRecord?.oemServiceEngineerName}</span>;
    },
  },
  {
    label: "Engine Serial Number",
    id: "engineNo",
  },
  {
    label: "Complaint Description",
    id: "customerComplaintCode",
    render: (data) => {
      return <span>{data?.customerComplaintCode?.description}</span>;
    },
  },
  {
    label: "Ticket Stage",
    id: "stage",
    render: (data) => {
      const engineReplacementStatus =
        data?.engineReplacement &&
        data?.engineReplacementStatus &&
        data?.engineReplacementStatus !== "APPROVED"
          ? convertToCamelCaseFromUnderScore(data?.engineReplacementStatus)
          : false;
      return (
        <>
          <span>{TICKET_STAGES[data.stage]}</span>
          <div
            style={{
              fontWeight: "bold",
              color:
                data?.engineReplacementStatus === "YET_TO_DISPATCH"
                  ? "red"
                  : "green",
            }}
          >
            {" "}
            {engineReplacementStatus && `(${engineReplacementStatus})`}
          </div>
        </>
      );
    },
  },
  {
    label: "Service Engineer",
    id: "serviceEngineer",
    render: (data) => {
      return (
        <Tooltip
          title={
            <Box sx={{ width: "200px" }}>
              {data?.serviceEngineer?.name ? (
                <div>
                  <Typography sx={{ textAlign: "center" }}>
                    {data.serviceEngineer.name}
                  </Typography>
                  <Typography sx={{ textAlign: "center" }}>
                    {data?.serviceEngineer?.email}
                  </Typography>
                  <Typography sx={{ textAlign: "center" }}>
                    {data?.serviceEngineer?.phoneNumber}
                  </Typography>
                </div>
              ) : (
                "Service Engineer	Not Assigned"
              )}
            </Box>
          }
          arrow
        >
          <span>{data?.serviceEngineer?.name || "Not assigned"}</span>
        </Tooltip>
      );
    },
  },

  {
    label: "Status",
    id: "status",
    render: (data) => {
      const value = getStatus(data);
      return (
        <span>
          <CustomChip
            label={value}
            colorKey={
              value === "Resolved"
                ? "green"
                : value === "Open"
                ? "orange"
                : "blue"
            }
          />
        </span>
      );
    },
  },
];

export const SERVICE_LABEL_MAP = {
  firstService: "1st Service",
  secondService: "2nd Service",
  thirdService: "3rd Service",
  fourthService: "4th Service",
};

export const getStatus = (data) => {
  const { underWarranty, status, serviceEngineer, dateOfInspection } = data;
  // if (
  //   status === "OPENED" &&
  //   underWarranty &&
  //   serviceEngineer &&
  //   dateOfInspection
  // ) {
  //   return "JI Date fixed";
  // } else if (status === "OPENED" && underWarranty && serviceEngineer) {
  //   return "Engineer Assigned";
  // } else if (status === "OPENED" && underWarranty) {
  //   return "Acknowledged";
  // } else if (status === "OPENED") {
  //   return "Open";
  // } else {
  //   return convertToCamelCaseFromUnderScore(status);
  // }
  if (status === "OPENED") {
    return "Open";
  } else if (status === "REOPENED") {
    return "Reopen";
  } else {
    return convertToCamelCaseFromUnderScore(status);
  }
};
